import HistoricalTransactionCostInquiry from './historical-transaction-cost-inquiry.vue'
export default HistoricalTransactionCostInquiry
